import React, { createContext, useContext, useState, useMemo } from "react";

const SeasonContext = createContext({
  selectedSeason: null,
  setSelectedSeason: () => {},
});

// Safely read from localStorage whether it's plain text or JSON
function safeRead(key) {
  const raw = localStorage.getItem(key);
  if (raw == null) return null;
  try {
    // if it was stored via JSON.stringify before, this will work
    return JSON.parse(raw);
  } catch {
    // otherwise just return the raw string
    return raw;
  }
}

export function SeasonProvider({ children }) {
  const [selectedSeason, _setSelectedSeason] = useState(() => {
    const v = safeRead("selectedSeason");
    // normalize to string or null
    return v == null ? null : String(v);
  });

  const value = useMemo(
    () => ({
      selectedSeason,
      setSelectedSeason: (v) => {
        const str = v == null ? "" : String(v);
        _setSelectedSeason(str || null);
        try {
          // Always store as a plain string (no JSON)
          localStorage.setItem("selectedSeason", str);
        } catch {}
      },
    }),
    [selectedSeason]
  );

  return <SeasonContext.Provider value={value}>{children}</SeasonContext.Provider>;
}

export function useSeason() {
  return useContext(SeasonContext);
}
